import { refillImportsFilter } from 'src/app/shared/utils/helpers';
import { Action, createReducer, on } from "@ngrx/store";
import * as importsActions from './imports.actions';
import { IExecuteSeccess, IImport, IImportFilter, IResponseMatching } from "../models/imports.models";
import { IPagination } from 'src/app/shared/models/page.model';

export interface ImportFilterState {
  advanced:IImportFilter
  keyword: string
}
export interface ImportProductsState {
  imports: IImport[];
  metadata: IPagination | null;
  responseMatching: IResponseMatching | null;
  deatailsImport: IExecuteSeccess | null
  loading: boolean;
  executeLoading: boolean;
  ImportFilterState: ImportFilterState;
}

export const initialImportProductsState: ImportProductsState = {
  imports: [],
  metadata: null,
  responseMatching : null,
  deatailsImport: null,
  loading: false,
  executeLoading: false,
  ImportFilterState: {
    advanced: refillImportsFilter(),
    keyword: ''
  }
}


const featureReducer = createReducer(
  initialImportProductsState,
  on(
    importsActions.GetImportsSuccess,
    (state, action) => ({
      ...state,
      imports: action.imports.data,
      metadata: action.imports.metadata
    })
  ),
  on(
    importsActions.ImportProductsSuccess,
    (state, action) => ({
      ...state,
      responseMatching: action.responseMatching,
    })
  ),
  on(
    importsActions.DetailsImportSuccess,
    (state, action) => ({
      ...state,
      deatailsImport: action.deatailsImport,
    })
  ),
  on(
    importsActions.SetImportLoader,
    (state, action) => ({
      ...state,
      loading: action.isLoading
    })
  ),
  on(
    importsActions.SetExecuteImportLoader,
    (state, action) => ({
      ...state,
      executeLoading: action.isLoading
    })
  ),
  on(
    importsActions.ClearDetailsImport,
    (state, action) => ({
      ...state,
      deatailsImport: null
    })
  ),
  on(
    importsActions.SetImportSearch,
    (state, action) => ({
      ...state,
      ImportFilterState: {
        ...state.ImportFilterState,
        searchImort: action.search}
    })
  ),
  on(
    importsActions.SetImportFilter,
    (state, action) => ({
      ...state,
      ImportFilterState:{
        advanced: action.advanced!,
        keyword : action.keyword
      }
    })
  ),
)

export function importProductsReducer(state: ImportProductsState | undefined, action: Action) {
  return featureReducer(state, action);
}
